<div class="center-container">
    <p></p>
</div>
<div class="center-container">
    <div class="container">
        <ul class="ul-spacing">
            <p class="mogTitle">Select Store</p>

            <li
                    *ngFor="let item of storeListContainer"
                    [class.item-selected]="item.selected"
                    (click)="toggleStoreSelection(item)"
            >
                {{item.identity}}
            </li>
        </ul>

        <div class="buttons-container">
            <app-mcl-button primary="true" (buttonPressed)="addStoresToGroup()" text="Add >>>"></app-mcl-button>
        </div>

        <ul class="ul-spacing">
            <p class="mogTitle">Select Group</p>
            <li
                    *ngFor="let group of groupList"
                    [class.item-selected]="group.selected"
                    (click)="toggleGroupSelection(group)">
                {{group.caption}}</li>
        </ul>
    </div>
</div>
<br>
<div class="center-container">
    <ul *ngFor="let group of groupMap | keyvalue" class="ul-spacing">
        <p class="mogTitle">{{group.key}}</p>
        <li
                *ngFor="let store of group.value"
                [class.item-selected]="store.selected"
                (click)="toggleGroupStoreSelection(store)">
            {{store.identity}}
        </li>
    </ul>
</div>

<div class="center-container">
    <app-mcl-button *ngIf="showDeleteButton" (buttonPressed)="deleteBtnClicked()" primary="true" text="Delete"></app-mcl-button>
</div>
<div kendoDialogContainer></div>

